// useTimelapseExportSupported — タイムラプス共有入口ボタンの表示ゲート (T3、
// growth-timelapse-share-2026-07-02.md §5.2「WebCodecs 非対応環境ではボタン非表示」)。
//
// `isTimelapseExportSupported()` (T2、実 probe = `VideoEncoder.isConfigSupported`
// を H.264 候補 config で試す。module cache 済) を React state に橋渡しする。
// 判定は async なので初期値 false → 対応環境では 1 render 後にボタンが現れる
// (disabled でなく **非表示** で始まるのが仕様通り)。ページ寿命内で答えは変わら
// ないので依存なし 1 回きり。

import { useEffect, useState } from 'react';

import { isTimelapseExportSupported } from '../../infrastructure/timelapse/support.js';

export const useTimelapseExportSupported = (): boolean => {
  const [supported, setSupported] = useState(false);
  useEffect(() => {
    let alive = true;
    void isTimelapseExportSupported().then((v) => {
      if (alive && v) setSupported(true);
    });
    return () => {
      alive = false;
    };
  }, []);
  return supported;
};
